import { render, staticRenderFns } from "./home3.vue?vue&type=template&id=15f72aac&scoped=true&"
import script from "./home3.vue?vue&type=script&lang=js&"
export * from "./home3.vue?vue&type=script&lang=js&"
import style0 from "./home3.vue?vue&type=style&index=0&id=15f72aac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f72aac",
  null
  
)

export default component.exports